// extracted by mini-css-extract-plugin
export var card = "_lx-5";
export var cardSelected = "_lx-4";
export var image = "_lx-3";
export var modal = "_lx-0";
export var modalContent = "_lx-1";
export var table = "_lx-2";